<template>
  <vue-json-excel
    :data="data"
    :fields="fields"
    :name="name"
    :title="title"
    :beforeGenerate="beforeGenerate"
    style="width: 100%"
  >
    {{ $gettext('Export') }}
  </vue-json-excel>
</template>

<script>
import VueJsonExcel from 'vue-json-excel';

export default {
  name: 'PosJsonExcel',
  components: {
    VueJsonExcel,
  },
  props: {
    data: { type: Array, default: () => ([]) },
    fields: {
      type: Object,
      default() {
        return {
          'Article Name': 'name',
          'Count' : {
            field: 'count',
            callback: value => this.printName(value, 'counts'),
          },
          'Quantity': 'quantity',
          'Barcode' : 'barcode',
        }
      },
    },
    name: { type: String, default: 'data.xls' },
    title: { type: Array, default: () => ([]) },
  },
  methods: {
    beforeGenerate() {
      this.$emit('beforeGenerate');
    },
  },
};
</script>
